
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as BulbIconComponent } from "./bulb-icon.svg";

export const BulbIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <BulbIconComponent {...props} />;
};
